import { generateRequest } from '.';
import { compact } from '../../lib/utils';
import { toQueryString } from '../../lib/utils/querystring';

export const Action = {
  Trends: {
    TrendPending: 'Trend_PENDING',
    TrendCompleted: 'Trend_FULFILLED',
    TrendFailed: 'Trend_FAILED',
  },
};

export const getTrends = queryParams => generateRequest({
  endpoint: `/assets-v2/api/trends?${toQueryString(compact(queryParams))}`,
  types: [
    Action.Trends.TrendPending,
    Action.Trends.TrendCompleted,
    Action.Trends.TrendFailed,
  ],
});
